import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/Share.svg'

export const IconShare = IconSVG as IconComponent
